import React from "react";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import CustomCard from "../CustomComponents/CustomCard/CustomCard";
import CustomCardContent from "../CustomComponents/CustomCardContent/CustomCardContent";
import clsx from "clsx";
import { useStyles } from "../../assets/jss/Dashboard";
import CustomDonut from "../CustomComponents/CustomDonut/CustomDonut";
import { driverStandard } from "../../services/DriverStandard";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import NoRecord from '../../assets/images/noRecord.svg';
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function DashboardDriverStandard(props:any) {
  const params = useParams();
  const { t } = useTranslation();
  const classes = useStyles();
  const [driverStandardData, setDriverStandardData] = React.useState<any>();
  const [
    driverStandardDataGraph,
    setDriverStandardDataGraph,
  ] = React.useState([]);
  const [isApiFailed, setIsApiFailed] = React.useState(false);
  const [isApiRespond, setIsApiRespond] = React.useState(false);
  const [driverStandardColors] = React.useState([
    "#2a5aff",
    "#00c2d5",
    "#f7c234",
  ]);

  //====
  const [statusValue, setStatusValue] = React.useState();
  const [alertMessage, setAlertMessage] = React.useState("");
  const [isAlertOpen, setIsAlertOpen] = React.useState(false);
  const changeApiStatusCodeFunc = (status) => {
    if (
      status.code &&
      status.code !== 0 &&
      status.code !== 200 &&
      status.code !== 201
    ) {
      setStatusValue(status.code);
      setAlertMessage(
        status.message
          ? status.message
          : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
      );
      setIsAlertOpen(true);
    }
  };
  //====

  React.useEffect(() => {
    async function getDriverStandard() {
      setStatusValue(null);
      setAlertMessage("");
      setIsAlertOpen(false);
      const data = await driverStandard(params);
      if (
        data &&
        (data.status.code === 0 ||
          data.status.code === 200 ||
          data.status.code === 201) &&
        data.content
      ) {
        setIsApiRespond(true);
        setDriverStandardData(data.content);
      } else {
        setIsApiRespond(true);
        setIsApiFailed(true);
        changeApiStatusCodeFunc(data.status);
      }
    }
    getDriverStandard();
  }, []);
  React.useEffect(() => {
    if (driverStandardData) {
      setDriverStandardDataGraph([
        {
          id: 1,
          name: t("DETERIORATING"),
          quantity:
            Math.round(
              (driverStandardData.deterioratingPercent + Number.EPSILON) * 100
            ) / 100,
          percentage:
            `${Math.round(
              (driverStandardData.deterioratingPercent + Number.EPSILON) * 100
            ) / 100}`,
        },
        {
          id: 2,
          name: t("IMPROVING"),
          quantity:
            Math.round(
              (driverStandardData.improvingPercent + Number.EPSILON) * 100
            ) / 100,
          percentage:
            `${Math.round(
              (driverStandardData.improvingPercent + Number.EPSILON) * 100
            ) / 100}`,
        },
        {
          id: 3,
          name: t("STATIC"),
          quantity:
            Math.round(
              (driverStandardData.staticPercent + Number.EPSILON) * 100
            ) / 100,
          percentage:
            `${Math.round(
              (driverStandardData.staticPercent + Number.EPSILON) * 100
            ) / 100}`,
        },
      ]);
    }
  }, [driverStandardData]);
  return (
    <>
      <CustomPaper square elevation={0} className={classes.height100}>
        <CustomCard
          elevation={0}
          className={clsx(classes.height100, classes.cardContentWrapper)}
        >
          <CustomCardContent className={classes.cardContent}>
            <CustomTypography
              className={classes.cardTitle}
              component="h4"
              variant="h4"
            >
              {t("DRIVER_STANDARDS")}
            </CustomTypography>
            {driverStandardData &&
              driverStandardData.deterioratingPercent === 0 &&
              driverStandardData.improvingPercent === 0 &&
              driverStandardData.staticPercent === 0 ? (
              <CustomBox className={classes.cardTitleSubText}>{t("NO_RECORD_GENERATED_YET")}</CustomBox>
            ) : null}
            <CustomGrid
              container
              justifyContent="center"
              alignItems="center"
              spacing={0}
              className={classes.graphContainer}
            >
              <CustomGrid item>
                {driverStandardData &&
                  driverStandardData.deterioratingPercent === 0 &&
                  driverStandardData.improvingPercent === 0 &&
                  driverStandardData.staticPercent === 0 ? (
                  <img src={NoRecord} />
                ) : driverStandardDataGraph && isApiRespond ? (
                  <CustomDonut
                    data={driverStandardDataGraph}
                    colors={driverStandardColors}
                    width={250}
                    height={250}
                    legendLabel={true}
                    externalRadius={110}
                    internalRadius={80}
                    isApiFailed={isApiFailed}
                  />
                ) : (
                  <CustomCircularProgress />
                )}
              </CustomGrid>
            </CustomGrid>
          </CustomCardContent>
        </CustomCard>
      </CustomPaper>
      <ErrorAlert
        code={statusValue}
        message={alertMessage}
        isOpen={isAlertOpen}
        isClose={(isClose) => setIsAlertOpen(!isClose)}
      />
    </>
  );
}
